import { InjectionToken, signal } from '@angular/core';

export const LOADING = new InjectionToken('globalLoader', {
  factory: () => signal(false),
});
